import { FocusEventHandler, useCallback } from 'react';
import { useScannerTarget } from './useScannerTarget';

export type UsePdaScannerInputOptions = {
    enabled?: boolean;
    disabled?: boolean;
    transform?: (value: string) => string;
    onScan: (value: string) => void | Promise<void>;
};

export const usePdaScannerInput = ({
    enabled = true,
    disabled = false,
    transform = (value) => value.trim(),
    onScan,
}: UsePdaScannerInputOptions) => {
    const handleScannerScan = useCallback(
        async (barcode: string) => {
            const nextValue = transform(barcode);

            if (!nextValue) return;

            await onScan(nextValue);
        },
        [onScan, transform],
    );

    const { activateScannerTarget, deactivateScannerTarget } = useScannerTarget({
        enabled: enabled && !disabled,
        onScan: handleScannerScan,
    });

    const onFocus: FocusEventHandler<HTMLInputElement | HTMLTextAreaElement> = () => {
        activateScannerTarget();
    };

    const onBlur: FocusEventHandler<HTMLInputElement | HTMLTextAreaElement> = () => {
        deactivateScannerTarget();
    };

    return {
        onFocus,
        onBlur,
    };
};
